/**
 * Service to manage tutorial visibility
 * Uses localStorage to track if the user has dismissed the tutorial
 */

const TUTORIAL_STORAGE_KEY = 'rondaybaciga_tutorial_dismissed';

class TutorialService {
    /**
     * Check if tutorial has been dismissed
     * @returns {boolean} True if tutorial was dismissed
     */
    isTutorialDismissed() {
        try {
            return localStorage.getItem(TUTORIAL_STORAGE_KEY) === 'true';
        } catch (error) {
            console.error('Error reading tutorial status from localStorage:', error);
            return false;
        }
    }

    /**
     * Check if tutorial should be shown
     * @returns {boolean} True if tutorial should be shown
     */
    shouldShowTutorial() {
        return !this.isTutorialDismissed();
    }

    /**
     * Mark tutorial as dismissed (don't show again)
     */
    dismissTutorial() {
        try {
            localStorage.setItem(TUTORIAL_STORAGE_KEY, 'true');
        } catch (error) {
            console.error('Error saving tutorial status to localStorage:', error);
        }
    }

    /**
     * Reset tutorial to show again (useful for testing or settings)
     */
    resetTutorial() {
        try {
            localStorage.removeItem(TUTORIAL_STORAGE_KEY);
        } catch (error) {
            console.error('Error clearing tutorial status from localStorage:', error);
        }
    }
}

// Export singleton instance
const tutorialService = new TutorialService();
export default tutorialService;
